import React from 'react';

const sectionStyle = {
    marginBottom: '2.5rem',
};

const h2Style = {
    fontSize: 'clamp(1.25rem, 2vw, 1.75rem)',
    marginBottom: '0.85rem',
    lineHeight: 1.15,
};

const pStyle = {
    fontSize: '1rem',
    lineHeight: 1.8,
    marginBottom: '1rem',
    maxWidth: '72ch',
};

export default function TermsService() {
    return (
        <main
            style={{
                minHeight: '100vh',
            }}
        >
            <section
                style={{
                    borderBottom: '1px solid var(--color-border, rgba(255,255,255,0.08))',
                    padding: '7rem 1.25rem 2.5rem',
                }}
            >
                <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                    <p
                        style={{
                            fontSize: '0.85rem',
                            letterSpacing: '0.08em',
                            textTransform: 'uppercase',
                            opacity: 0.65,
                            marginBottom: '1rem',
                        }}
                    >
                        Legal / Terms
                    </p>
                    <h1
                        style={{
                            fontSize: 'clamp(2.5rem, 8vw, 6rem)',
                            lineHeight: 0.95,
                            marginBottom: '1.25rem',
                            maxWidth: '10ch',
                        }}
                    >
                        Terms of Service
                    </h1>
                    <p style={{ ...pStyle, fontSize: '1.1rem', maxWidth: '62ch' }}>
                        These Terms of Service govern your use of the Meshae Studios website, products, apps, tools, content, and services. By accessing or using a Meshae Studios site or app, you agree to these terms.
                    </p>
                    <p style={{ ...pStyle, marginBottom: 0 }}>Last updated: April 17, 2026</p>
                </div>
            </section>

            <section style={{ padding: '3rem 1.25rem 6rem' }}>
                <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                    <div style={{ maxWidth: '760px' }}>
                        <section style={sectionStyle}>
                            <h2 style={h2Style}>Who we are</h2>
                            <p style={pStyle}>
                                Meshae Studios is a creative and digital services business. In these Terms, “Meshae Studios,” “we,” “our,” and “us” refer to Meshae Studios and the websites, applications, products, and services we own or operate.
                            </p>
                        </section>

                        <section style={sectionStyle}>
                            <h2 style={h2Style}>Acceptance of these terms</h2>
                            <p style={pStyle}>
                                By accessing, browsing, creating an account for, connecting a third-party account to, or otherwise using a Meshae Studios website or app, you agree to be bound by these Terms of Service and our Privacy Policy.
                            </p>
                            <p style={pStyle}>
                                If you do not agree to these terms, do not use our services.
                            </p>
                        </section>

                        <section style={sectionStyle}>
                            <h2 style={h2Style}>Eligibility</h2>
                            <p style={pStyle}>
                                You may use our services only if you can form a binding agreement under applicable law and are not prohibited from using the services under any applicable laws or regulations.
                            </p>
                            <p style={pStyle}>
                                If you use our services on behalf of a business or organization, you represent that you have authority to bind that entity to these Terms.
                            </p>
                        </section>

                        <section style={sectionStyle}>
                            <h2 style={h2Style}>Using our services</h2>
                            <p style={pStyle}>
                                You may use Meshae Studios services only for lawful purposes and in accordance with these Terms. You agree not to misuse the site or any app, interfere with its operation, attempt unauthorized access, reverse engineer protected features, or use the service to violate laws, rights, or platform rules.
                            </p>
                            <p style={pStyle}>
                                You may not use our services to upload, post, transmit, or facilitate content that is unlawful, deceptive, abusive, infringing, fraudulent, or harmful.
                            </p>
                        </section>

                        <section style={sectionStyle}>
                            <h2 style={h2Style}>Accounts and connected platforms</h2>
                            <p style={pStyle}>
                                Some Meshae Studios features may require you to connect an account from a third-party platform such as Meta, Instagram, or Threads. You are responsible for the account information you provide, for maintaining the security of your credentials, and for all activity that occurs under your connected accounts.
                            </p>
                            <p style={pStyle}>
                                Your use of third-party platform integrations is also subject to the terms, policies, and rules of those third-party services.
                            </p>
                        </section>

                        <section style={sectionStyle}>
                            <h2 style={h2Style}>Intellectual property</h2>
                            <p style={pStyle}>
                                Unless otherwise stated, the Meshae Studios website, apps, branding, design, text, graphics, code, software, workflows, and related materials are owned by Meshae Studios or its licensors and are protected by intellectual property laws.
                            </p>
                            <p style={pStyle}>
                                These Terms do not grant you ownership of any Meshae Studios intellectual property. You may not copy, modify, distribute, license, sell, or exploit our content, software, or branding except as expressly permitted in writing.
                            </p>
                        </section>

                        <section style={sectionStyle}>
                            <h2 style={h2Style}>Your content</h2>
                            <p style={pStyle}>
                                If you submit content, data, messages, or materials to Meshae Studios, you represent that you have the rights necessary to do so. You retain ownership of your content, but you grant us a limited right to host, process, transmit, and use that content as needed to provide the service you requested.
                            </p>
                            <p style={pStyle}>
                                We may remove content or suspend access if we reasonably believe it violates these Terms, infringes rights, creates risk, or exposes us or others to liability.
                            </p>
                        </section>

                        <section style={sectionStyle}>
                            <h2 style={h2Style}>Fees, payments, and refunds</h2>
                            <p style={pStyle}>
                                Some services may be offered for a fee. If you purchase a paid service, you agree to provide accurate payment information and to pay all fees as described at the time of purchase.
                            </p>
                            <p style={pStyle}>
                                Unless otherwise stated in a written agreement, proposal, or purchase terms, payments are non-refundable once work has started or access to a paid service has been provided.
                            </p>
                        </section>

                        <section style={sectionStyle}>
                            <h2 style={h2Style}>Availability and changes</h2>
                            <p style={pStyle}>
                                We may modify, suspend, discontinue, or update any part of the site or services at any time, with or without notice. We are not liable if part of the service is unavailable, delayed, changed, or removed.
                            </p>
                        </section>

                        <section style={sectionStyle}>
                            <h2 style={h2Style}>Termination</h2>
                            <p style={pStyle}>
                                We may suspend or terminate your access to Meshae Studios services at any time if we believe you violated these Terms, created risk for us or others, or used the service in a way that is unlawful, abusive, or harmful.
                            </p>
                            <p style={pStyle}>
                                You may stop using our services at any time. Sections that by their nature should survive termination will continue to apply, including ownership, disclaimers, limitations of liability, and dispute-related provisions.
                            </p>
                        </section>

                        <section style={sectionStyle}>
                            <h2 style={h2Style}>Third-party services and links</h2>
                            <p style={pStyle}>
                                Our website or apps may contain links to or integrations with third-party sites, tools, platforms, or services. We do not control and are not responsible for third-party services, content, security, or policies.
                            </p>
                        </section>

                        <section style={sectionStyle}>
                            <h2 style={h2Style}>Disclaimers</h2>
                            <p style={pStyle}>
                                Meshae Studios services are provided on an “as is” and “as available” basis. To the fullest extent permitted by law, we disclaim all warranties, express or implied, including warranties of merchantability, fitness for a particular purpose, non-infringement, and availability.
                            </p>
                            <p style={pStyle}>
                                We do not guarantee that the services will be uninterrupted, secure, error-free, or suitable for every use case.
                            </p>
                        </section>

                        <section style={sectionStyle}>
                            <h2 style={h2Style}>Limitation of liability</h2>
                            <p style={pStyle}>
                                To the fullest extent permitted by law, Meshae Studios and its owners, operators, affiliates, contractors, and service providers will not be liable for any indirect, incidental, consequential, special, punitive, or exemplary damages, or for any loss of profits, revenue, data, goodwill, or business opportunities arising out of or related to your use of the services.
                            </p>
                            <p style={pStyle}>
                                To the fullest extent permitted by law, our total liability for any claim arising out of or relating to the services will not exceed the amount you paid us, if any, for the specific service giving rise to the claim during the 12 months before the claim arose.
                            </p>
                        </section>

                        <section style={sectionStyle}>
                            <h2 style={h2Style}>Indemnification</h2>
                            <p style={pStyle}>
                                You agree to defend, indemnify, and hold harmless Meshae Studios and its affiliates, owners, contractors, and service providers from and against claims, liabilities, damages, losses, and expenses arising out of your use of the services, your content, your violation of these Terms, or your violation of any law or third-party right.
                            </p>
                        </section>

                        <section style={sectionStyle}>
                            <h2 style={h2Style}>Governing law</h2>
                            <p style={pStyle}>
                                These Terms are governed by the laws of the State of Florida, without regard to conflict of law principles, except to the extent superseded by applicable federal law.
                            </p>
                        </section>

                        <section style={sectionStyle}>
                            <h2 style={h2Style}>Changes to these terms</h2>
                            <p style={pStyle}>
                                We may revise these Terms of Service from time to time. When we do, we will update the “Last updated” date above. Your continued use of the services after updated terms are posted means you accept the revised terms.
                            </p>
                        </section>

                        <section style={{ ...sectionStyle, marginBottom: 0 }}>
                            <h2 style={h2Style}>Contact</h2>
                            <p style={pStyle}>
                                If you have questions about these Terms of Service, contact Meshae Studios at <a href="mailto:admin@meshaestudios.com" style={{ color: 'inherit' }}>admin@meshaestudios.com</a>.
                            </p>
                        </section>
                    </div>
                </div>
            </section>
        </main>
    );
}
